import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

export const CopyTemplate = ({ show, data, toggle, onSubmit }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    templateName: "",
    templateCategory: "",
  });

  const { templateName, templateCategory } = formData;

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      templateCategory: data.category,
    }));
  }, [data]);

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onApply = () => {
    onSubmit(formData);
    toggle();
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">
          {t("auth.email.template.copyTemplateTitle")}
        </h5>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="">{t("common.label.name")}</label>
          <input
            type="text"
            className="form-control plutoinput-form-control"
            name="templateName"
            value={templateName}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="">{t("common.label.category")}</label>
          <input
            type="text"
            className="form-control plutoinput-form-control"
            name="templateCategory"
            value={templateCategory}
            onChange={handleChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={toggle}
        >
          {t("common.button.cancel")}
        </button>
        <button type="button" className="btn btn-primary" onClick={onApply}>
          {t("common.button.save")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
